<div mat-dialog-title class="d-flex justify-content-between align-items-center" style="margin-bottom: 38px;">
    <h2 class="m-0">{{ parentData.title }}</h2>
    <button mat-icon-button mat-dialog-close>
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <mat-dialog-content >
    <form >
        <div class="row g-2 mb-3 justify-content-between phone-field">
          <mat-form-field class="col-sm-3" appearance="outline" class>
            <mat-select
              placeholderLabel="Search"
              name="primarySelectedSpecialityCtrl"
              [(value)]="selectedCountry"
              (selectionChange)="onCountrySelected($event)"
              #primarySpecialitiesSelector
            >
              <mat-option>
                <ngx-mat-select-search
                  noEntriesFoundLabel="no results found"
                  name="countrysearch"
                  placeholderLabel="Enter country name"
                  [formControl]="searchString"
                  (keyup)="onKey()"
                ></ngx-mat-select-search>
              </mat-option>
              <mat-option
                *ngFor="let country of countryList"
                [value]="country"
              >
                {{ country.flag }} {{ country.name }}
                {{ "(" + country.dial_code + ")" }}
              </mat-option>
            </mat-select>
          </mat-form-field>
         
          <mat-form-field appearance="outline" >
            <mat-label>New phone number</mat-label>
            <input
              matInput
              name="phone"
              [disabled]="toShowFinal"
              type="tel"
              maxlength="17"
              minlength="3"
              [(ngModel)]="phone"
              required
              placeholder="Enter phone number"
            />
            <!-- <button style="position: relative;top: -6px;color: #FFC107;"
              type="button"
              mat-button
              matSuffix
              color="primary"
              [disabled]="
                countryCode.invalid ||
                phoneControl.invalid ||
                sendingOtpStatus"
              (click)="onSendOTP()"
            >
              Send OTP
            </button> -->
            <mat-error>Invalid phone number!</mat-error>
            <!-- <mat-hint>Enter 10 digit phone number</mat-hint> -->
          </mat-form-field>
        </div>
        <!-- *ngIf="otpReceived" -->
        <div class="mb-3" *ngIf="otpReceived">
          <!-- <mat-form-field appearance="outline" class="w-100">
            <mat-label>Enter OTP</mat-label>
            <input
              matInput
              type="tel"
              maxlength="6"
              formControlName="otp"
              required
            />
            <mat-error>Invalid OTP</mat-error>
          </mat-form-field> -->

          <!-- <div class="sent_ck">
            <p>Code is sent to 928935555</p>
          </div> -->
          <div class="otp-container">
            <input
              type="tel"
              maxlength="1"
              class="otp-input"
              (input)="onInput($event, 0)"
              name="first"
              [(ngModel)]="otp[0]"
              id="box0"
            />
            <input
              type="tel"
              maxlength="1"
              class="otp-input"
              (input)="onInput($event, 1)"
              name="second"
              [(ngModel)]="otp[1]"
              id="box1"
            />
            <input
              type="tel"
              maxlength="1"
              class="otp-input"
              (input)="onInput($event, 2)"
              name="third"
              [(ngModel)]="otp[2]"
              id="box2"
            />
            <input
              type="tel"
              maxlength="1"
              class="otp-input"
              (input)="onInput($event, 3)"
              name="fourth"
              [(ngModel)]="otp[3]"
              id="box3"
            />
            <input
              type="tel"
              maxlength="1"
              class="otp-input"
              (input)="onInput($event, 4)"
              name="fifth"
              [(ngModel)]="otp[4]"
              id="box4"
            />
            <input
              type="tel"
              maxlength="1"
              class="otp-input"
              (input)="onInput($event, 5)"
              name="sixth"
              [(ngModel)]="otp[5]"
              id="box5"
            />
          </div>
          <div class="small_tht">
            <p>
              Enter the verification code you received in your mobile from LookzUp platform.
            </p>
          </div>
        </div>

        <!-- <mat-form-field appearance="outline" class="w-100" color="accent">
            <mat-label>Password</mat-label>
            <input matInput placeholder="Enter password" [type]="passwordHide ? 'password' : 'text'" formControlName="password">
            <button mat-icon-button matSuffix (click)="passwordHide = !passwordHide" [attr.aria-label]="'Hide password'" [attr.aria-pressed]="passwordHide">
                <mat-icon class="material-icons-round">{{passwordHide ? 'visibility_off' : 'visibility'}}</mat-icon>
            </button>
            <mat-hint>Minimum 6 characters</mat-hint>
            <mat-error>Enter password</mat-error>
          </mat-form-field> -->
        <button
        
          mat-flat-button
          color="accent"
          id="first-form1"
          class="w-100 full-width1"
          [disabled]="
          !phone || phone.length < 3 || phone.length > 17 || sendingOtpStatus"
        (click)="onSendOTP()"
          
          #submitButton
        >
          Verify mobile
        </button>
        <button
        *ngIf="toShowFinal"
          mat-flat-button
          color="accent"
          class="w-100"
          
        (click)="changePhoneNumber()"
        >
          Change phone number
        </button>
      </form>
      
  </mat-dialog-content>
<!-- 
  <mat-dialog-content *ngIf="editMode">
    <div>
      <mat-form-field appearance="outline">
        <mat-label>Amount</mat-label>
        <input
          [(ngModel)]="editCreditData.amount"
          matInput
          #input
        />
      </mat-form-field>
    </div>
    <div class="radio_group">
        <label>Status: </label>
        <mat-radio-group [(ngModel)]="editCreditData.status">
          <mat-radio-button [value]="1">Active</mat-radio-button>
          <mat-radio-button [value]="0">Paid Fully</mat-radio-button>
        </mat-radio-group>
      </div>
  </mat-dialog-content> -->
  
  <!-- <mat-dialog-actions align="end" >
    <button mat-button mat-dialog-close>Cancel</button>
    <button
      mat-flat-button
      color="accent"
      (click)="checkUser()"
    >
      check
    </button>
    <button
      mat-flat-button
      color="accent"
      (click)="deleteUser()"
    >
      delete
    </button>
  </mat-dialog-actions> -->
  